import { cn } from "../../lib/cn";
import { AnimatedNumber } from "../primitives/AnimatedNumber";
import type { Parameter } from "../../stores/equationPlayground";

interface ParameterSliderProps {
  parameter: Parameter;
  onChange: (value: number) => void;
  className?: string;
}

function ParameterSlider({ parameter, onChange, className }: ParameterSliderProps) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <span className="w-6 text-right text-[11px] font-mono font-medium text-[var(--text-secondary)]">
        {parameter.name}
      </span>
      <input
        type="range"
        min={parameter.min}
        max={parameter.max}
        step={parameter.step}
        value={parameter.value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className="flex-1 h-1 appearance-none rounded-full bg-[var(--border-default)] accent-[var(--color-lever-orange)] cursor-pointer [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-[var(--color-lever-orange)] [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:shadow-[var(--shadow-sm)]"
      />
      <AnimatedNumber
        value={parameter.value}
        format={(n) => n.toFixed(1)}
        className="w-10 text-right text-[11px] font-mono font-medium text-[var(--text-primary)]"
      />
    </div>
  );
}

ParameterSlider.displayName = "ParameterSlider";

export { ParameterSlider };
export type { ParameterSliderProps };
